import { HTTP_STATUS_CONFLICT } from '../../../../constants/api'
import { NOTIFICATION_TYPE } from '../../../../constants/common'
import {
  APPLICANT_STAGE,
  getIsMockApplicantId,
} from '../../../RentalPortalApplicant'
import { getIsApplicantClosed } from '../RentalPortalApplicantProfile.utils'

import { APPLICANT_PROFILE_BLOCK_CONFLICT_NOTIFICATION_ID } from './RentalPortalApplicantProfileTabOverview.constants'

export function getCanEditApplicantBlock(applicantData) {
  return Boolean(
    !getIsApplicantClosed(applicantData) && applicantData?.permissions?.can_edit
  )
}

export function getIsApplicantWidgetSkeleton({ applicantData, isInitiated }) {
  return !isInitiated || !applicantData
}

export function getIsApplicantIdentityFrozen(applicantData) {
  return Boolean(applicantData?.selected_at)
}

export function getIsApplicantPoolStage(applicantData) {
  return applicantData?.stage === APPLICANT_STAGE.pool
}

export function getHasApplicantDocumentChecklist(applicantData) {
  return (
    Boolean(applicantData?.stage) && !getIsApplicantPoolStage(applicantData)
  )
}

// TODO: show the credit check for backend applicants once the backend serves it
export function getHasApplicantCreditCheckBlock(applicantData) {
  return (
    !applicantData ||
    getIsMockApplicantId(applicantData.id) ||
    Boolean(applicantData.credit_check)
  )
}

export function getIsApplicantTerminalStage(applicantData) {
  return Boolean(
    applicantData?.phase?.is_terminal ||
    applicantData?.terminal_at ||
    applicantData?.archived
  )
}

export function getIsApplicantBlockConflictError(error) {
  return error?.response?.status === HTTP_STATUS_CONFLICT
}

export function getApplicantBlockConflictNotification({
  t,
  onClickOverwrite,
  onClickReload,
}) {
  return {
    actions: [
      {
        callback: onClickReload,
        text: t('RentalPortal.ApplicantProfileBlockConflictReloadBtnKey'),
      },
      {
        callback: onClickOverwrite,
        text: t('RentalPortal.ApplicantProfileBlockConflictOverwriteBtnKey'),
      },
    ],
    id: APPLICANT_PROFILE_BLOCK_CONFLICT_NOTIFICATION_ID,
    text: t('RentalPortal.ApplicantProfileBlockConflictKey'),
    type: NOTIFICATION_TYPE.warning,
  }
}
